import { render } from "./dashboardSidebar.vue?vue&type=template&id=eb9aec32&scoped=true"
import script from "./dashboardSidebar.vue?vue&type=script&lang=js"
export * from "./dashboardSidebar.vue?vue&type=script&lang=js"

import "./dashboardSidebar.vue?vue&type=style&index=0&id=eb9aec32&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb9aec32"]])

export default __exports__